// src/components/Footer.jsx
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaCheckCircle } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom'; // ✅ Add useNavigate

export default function Footer() {
  const navigate = useNavigate(); // ✅ Create navigate function

  return (
    <footer className="bg-[#07082a] text-white">
      {/* Top Call to Action */}
      <div className="bg-gradient-to-b from-orange-600 to-black px-6 py-8 flex flex-col md:flex-row items-center justify-between">
        <h2 className="text-2xl md:text-3xl font-bold mb-4 md:mb-0">
          Looking For The Aviation Solutions ?
        </h2>
        <button
          onClick={() => navigate("/contact")} // ✅ Navigate to /contact when clicked
          className="bg-gradient-to-r from-orange-500 to-orange-300 text-black font-medium px-6 py-3 rounded-full shadow-lg"
        >
          Get a quote →
        </button>
      </div>

      {/* Footer Main Grid */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 px-6 md:px-16 py-10 text-sm md:text-base">
        {/* Logo & About */}
        <div>
          <img src="/swati-logo.png" alt="Swati Logo" className="h-24 mb-4" />
          <p>
            Established in 2012, 1000+ Onsite support team, Active in more than 26 Airports,
            specialized in the field.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-bold mb-4">Quick Links</h3>
          <ul className="space-y-2">
            <li className="flex items-center gap-2"><FaCheckCircle className="text-orange-500" /><Link to="/">Home</Link></li>
            <li className="flex items-center gap-2"><FaCheckCircle className="text-orange-500" /><Link to="/about">About Us</Link></li>
            <li className="flex items-center gap-2"><FaCheckCircle className="text-orange-500" /><Link to="/products">Products</Link></li>
            <li className="flex items-center gap-2"><FaCheckCircle className="text-orange-500" /><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        {/* Services */}
        <div>
          <h3 className="text-lg font-bold mb-4">Services</h3>
          <ul className="space-y-2">
            <li className="flex items-center gap-2"><FaCheckCircle className="text-orange-500" /><Link to="/services">Installation Commissioning</Link></li>
            <li className="flex items-center gap-2"><FaCheckCircle className="text-orange-500" /><Link to="/services">Operation & Maintenance</Link></li>
            <li className="flex items-center gap-2"><FaCheckCircle className="text-orange-500" /><Link to="/services">Repair & Refurbishment</Link></li>
            <li className="flex items-center gap-2"><FaCheckCircle className="text-orange-500" /><Link to="/services">Technical Assessment</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-lg font-bold mb-4">Connect With Us</h3>
          <ul className="space-y-3">
            <li className="flex items-start gap-2">
              <FaMapMarkerAlt className="text-orange-500 mt-1" />
              Unit no: 302, 3rd Floor, Block-B, Asian Suncity, Kothaguda Village,<br />Hyderabad 500084 Telangana, India
            </li>
            <li className="flex items-center gap-2">
              <FaEnvelope className="text-orange-500" /><a href="mailto:support@sasgroups.net">support@sasgroups.net</a>
            </li>
            <li className="flex items-center gap-2">
              <FaPhoneAlt className="text-orange-500" /><a href="tel:+919704777822">+91-40-4504-8332</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="border-t border-gray-600 py-4 px-6 flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
        <p>© 2025 Swati Airport. All rights reserved.</p>
        <p>
          Site Developed And Maintained By <span className="text-white">Swati IT Team</span>
        </p>
      </div>
    </footer>
  );
}
